import WAStateParksinsons20251 from "../Assets/WA-State-Parksinsons-2025-1.jpeg";
import TableTennis4Disability from "../Assets/TableTennis-4-Disability.jpeg";
import TriValleyApr2026Camp6 from "../Assets/Dublin-Apr2026-Camp-6.jpeg";
import ParkinsonWalkthon1 from "../Assets/ParkinsonWalkthon-1.jpeg";
import Jun27Ahan3 from "../Assets/27June2026-Ahan-3.jpeg";
import May23_3 from "../Assets/23May-3.jpeg";

const MomentsPhotos = [
  {
    img: WAStateParksinsons20251,
    alt: "WA State Parkinson's 2025 Tournament.",
  },  
  {
    img: TableTennis4Disability,
    alt: "Table Tennis for Disability.",
  },
  {
    img: TriValleyApr2026Camp6,
    alt: "Tri-Valley April 2026 Camp.",
  },
  {
    img: Jun27Ahan3,
    alt: "One-on-one coaching at the Seattle Pacific Table Tennis Club — June 27, 2026.",
  },
  {
    img: ParkinsonWalkthon1,
    alt: "Walk for Parkinson's 2026 — Table Tennis for Parkinson's Wellness booth.",
  }
  ,
  {
    img: May23_3,
    alt: "Participant smiling - May 23, 2026 Seattle Parkinson's Table Tennis",
  }
];

export default MomentsPhotos;